import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '../pipes/pipes.module';
import { CarteComponent } from './carte/carte.component';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        PipesModule
    ],
    declarations: [
        CarteComponent,
    ],
    exports: [
        CarteComponent
    ]
})
export class ComponentsModule { }